import React, { useState, useEffect } from 'react';
import moment from 'moment';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Loader from 'react-loader';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getPatientStats, getEmailMilestone, getLoginMilestone, getFormMilestone, getProcessTracker } from './actions';
import DatePickerRange from '../../components/DatePickerRange/DatePickerRange';
import MilestoneSlidingPane from '../../components/SlidingPane/MilestoneSlidingPane';
import ActionTable from '../../components/Table';

function InteractionsTable(props) {
  const [practiceId, setPracticeId] = useState(localStorage.getItem('__practiceId__'));
  const [providerId, setProviderId] = useState(localStorage.getItem('__providerId__'));
  const [calenderOpen, setCalenderOpen] = useState(false);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [emailSlidePaneOpen, setEmailSlidePaneOpen] = useState(false);
  const [loginSlidePaneOpen, setLoginSlidePaneOpen] = useState(false);
  const [formSlidePaneOpen, setFormSlidePaneOpen] = useState(false);
  const [processTrackerOpen, setProcessTrackerOpen] = useState(false);

  function setInteractionTableRange(range) {
    let { from, to } = range;
    from = moment(from).format('MM-DD-YYYY');
    to = moment(to).format('MM-DD-YYYY');
    setStartDate(from);
    setEndDate(to);
    props.getPatientStats(practiceId, providerId, from, to);
    setCalenderOpen(false);
  }

  function getPatientEmailInteraction(obj) {
    const { chrId: patientId, appointmentId } = obj;
    setEmailSlidePaneOpen(true);
    props.getEmailMilestone(patientId, appointmentId);
  }

  function getPatientLoginInteraction(obj) {
    const { chrId: patientId, appointmentId } = obj;
    setLoginSlidePaneOpen(true);
    props.getLoginMilestone(patientId, appointmentId);
  }
  function getPatientFormInteraction(obj) {
    const { chrId: patientId, appointmentId } = obj;
    setFormSlidePaneOpen(true);
    props.getFormMilestone(patientId, appointmentId);
  }
  function handleMilestoneData() {
    if (emailSlidePaneOpen) {
      return props.emailMileStone;
    } else if (loginSlidePaneOpen) {
      return props.loginMileStone;
    } else if (formSlidePaneOpen) {
      return props.formMileStone;
    }
    return [];
  }

  function handleAppointmentProcessTracker(appointmentId) {
    setProcessTrackerOpen(true);
    props.getProcessTracker(appointmentId);
  }

  function renderProcessTracker() {
    if (props.processTrackerData && processTrackerOpen) {
      return (
        <div>
          {Object.keys(props.processTrackerData.actions).map((t) => (
            <p key={t}>
              {props.processTrackerData.actions[t] ? <i className="fa fa-check" style={{ color: '#6fba1c' }} /> : <i className="fa fa-times" style={{ color: '#f34349' }} />} {`  ${t}`}
            </p>
          ))}
        </div>
      );
    } else {
      return null;
    }
  }

  return (
    <Container fluid style={{ backgroundColor: '#fff', height: '100vh' }}>
      <Loader loaded={!props.loading} />
      <Row>
        <Col xs="12">
          <div style={{ padding: 20, cursor: 'pointer', userSelect: 'none' }} onClick={() => setCalenderOpen(!calenderOpen)}>
            <i className="fa fa-calendar picker" aria-hidden="true" style={{ cursor: 'pointer' }} />
            <h5 style={{ display: 'inline' }}>{`Selected Range from ${startDate} - ${endDate}`}</h5>
          </div>
          {calenderOpen ? <DatePickerRange handleSetRange={setInteractionTableRange} /> : null}
          <ActionTable
            tableData={props.patientStats}
            patientClicked={(id) => console.log(id)}
            onEmailClick={getPatientEmailInteraction}
            onLoginClick={getPatientLoginInteraction}
            onFormClick={getPatientFormInteraction}
            onAppointmentClick={(appointmentId) => handleAppointmentProcessTracker(appointmentId)}
          />
          <MilestoneSlidingPane
            isOpen={emailSlidePaneOpen || loginSlidePaneOpen || formSlidePaneOpen || processTrackerOpen}
            closeSlidingPane={() => {
              setEmailSlidePaneOpen(false);
              setLoginSlidePaneOpen(false);
              setFormSlidePaneOpen(false);
              setProcessTrackerOpen(false);
            }}
            milestoneData={handleMilestoneData()}
          >
            {renderProcessTracker()}
          </MilestoneSlidingPane>
        </Col>
      </Row>
    </Container>
  );
}

InteractionsTable.propTypes = {
  getPatientStats: PropTypes.func,
  patientStats: PropTypes.array,
  getEmailMilestone: PropTypes.func,
  getLoginMilestone: PropTypes.func,
  getFormMilestone: PropTypes.func,
  getProcessTracker: PropTypes.func,
  emailMileStone: PropTypes.array,
  loginMileStone: PropTypes.array,
  formMileStone: PropTypes.array,
  processTrackerData: PropTypes.object,
  loading: PropTypes.bool,
};
function mapStateToProps({ ptInteractions }) {
  return {
    patientStats: ptInteractions.patientStats,
    emailMileStone: ptInteractions.emailMileStone,
    loginMileStone: ptInteractions.loginMileStone,
    formMileStone: ptInteractions.formMileStone,
    loading: ptInteractions.loading,
    processTrackerData: ptInteractions.processTrackerData,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getPatientStats,
      getEmailMilestone,
      getLoginMilestone,
      getFormMilestone,
      getProcessTracker,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(InteractionsTable);
